<div class="auth-wrapper auth-v2">
    <app-language-selector></app-language-selector>
      <div class="auth-inner max-width row m-0">
          <div class="d-flex align-items-center p-5 l-side">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-3">
                  <img
                          class="img-fluid"
                          [src]="
              coreConfig.layout.skin === 'dark'
                ? 'assets/images/pages/register-v1-dark.svg'
                : 'assets/images/register-1.svg'
            "
                          alt="Register v1"
                  />
              </div>
          </div>
          <!-- /Left Text-->
          <!-- Register-->
          <div class="d-flex align-items-center auth-bg r-side">
              <div class="mx-auto login-form">
                  <div class="company-logo" *ngIf="logo">
                      <img src="{{logo}}" alt="">
                  </div>
                  <h2 class="card-title mb-1">{{'REGISTER.HELLO_MESSAGE' | translate}}{{'REGISTER.TITLE1' | translate}}</h2>
                  <p class="card-text mb-2">{{'REGISTER.TITLE2' | translate}}</p>
                  <form class="auth-register-form mt-2" [formGroup]="registerForm">
                      <div class="form-group">
                          <label for="register-password" class="form-label">{{'REGISTER.SET_PASSWORD' | translate}}</label>

                          <div class="input-group input-group-merge form-password-toggle">
                              <input
                                      [type]="passwordTextType ? 'text' : 'password'"
                                      formControlName="password"
                                      id="register-password"
                                      class="form-control form-control-merge"
                                      placeholder="············"
                                      aria-describedby="register-password"
                                      tabindex="3"
                                      [ngClass]="{ 'is-invalid error': (f.password.dirty || f.password.touched) && f.password.errors }"
                              />
                              <div class="input-group-append">
                                  <span class="input-group-text cursor-pointer" (click)="togglePasswordTextType()">
                                    <i *ngIf="passwordTextType" class="feather icon-eye-off"></i>
                                    <i *ngIf="!passwordTextType" class="feather icon-eye"></i>
                                  </span>
                                </div>

                          </div>
                          <div
                                  *ngIf="(f.password.dirty || f.password.touched) && f.password.errors"
                                  class="invalid-feedback"
                                  [ngClass]="{ 'd-block': (f.password.dirty || f.password.touched) && f.password.errors }"
                          >
                              <div *ngIf="f.password.errors.required">{{'RESET_PASSWORD.PASSWORD_REQUIRED' | translate}}</div>
                          </div>
                          <ng-container  *ngIf="(f.password.dirty || f.password.touched) &&  f.password.errors">
                              <span class="p-required r1" *ngIf="f.password.errors.requiredLength"><i
                                      class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_LENGTH' | translate}}</span>
                              <span class="p-required r2" *ngIf="f.password.errors.hasUpperCase"><i
                                      class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_UPPERCASE' | translate}}</span>
                              <span class="p-required r3" *ngIf="f.password.errors.hasLowerCase"><i
                                      class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_LOWERCASE' | translate}}</span>
                              <span class="p-required r4" *ngIf="f.password.errors.hasNumeric"><i
                                      class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_NUMERIC' | translate}}</span>
                              <span class="p-required r5" *ngIf="f.password.errors.hasSpecialChar"><i
                                      class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_SPECIAL_CHAR' | translate}}</span>
                              <span class="p-required r6" *ngIf="f.password.errors.hasSpecialChar"><i
                                      class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_MATCH_EMAIL' | translate}}</span>
                          </ng-container>

                      </div>

                      <div class="form-group">
                          <label for="register-repet-password" class="form-label">{{'RESET_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate}}</label>

                          <div class="input-group input-group-merge form-password-toggle">
                              <input
                                      [type]="passwordTextType ? 'text' : 'password'"
                                      formControlName="confirmPassword"
                                      id="register-repet-password"
                                      class="form-control form-control-merge"
                                      placeholder="············"
                                      aria-describedby="register-repet-password"
                                      tabindex="3"
                                      [ngClass]="{ 'is-invalid error': (f.confirmPassword.dirty || f.confirmPassword.touched) && f.confirmPassword.errors }"
                              />
                              <div class="input-group-append">
                                  <span class="input-group-text cursor-pointer" (click)="togglePasswordTextType()">
                                    <i *ngIf="passwordTextType" class="feather icon-eye-off"></i>
                                    <i *ngIf="!passwordTextType" class="feather icon-eye"></i>
                                  </span>
                                </div>

                          </div>
                          <div
                                  *ngIf="(f.confirmPassword.dirty || f.confirmPassword.touched) && f.confirmPassword.errors"
                                  class="invalid-feedback"
                                  [ngClass]="{ 'd-block': (f.confirmPassword.dirty || f.confirmPassword.touched) && f.confirmPassword.errors }"
                          >
                              <div *ngIf="f.confirmPassword.errors.required">{{'RESET_PASSWORD.PASSWORD_REQUIRED' | translate}}</div>
                              <div *ngIf="f.confirmPassword.errors.missMatch">{{'RESET_PASSWORD.CONFIRM_PASSWORD_MISSMATCH' | translate}}</div>
                          </div>
                      </div>

                      <!-- Company Terms & Conditions -->
                      <div class="form-group" *ngIf="tosDocumentUrl">
                          <span>{{'REGISTER.AGREE' | translate}} <a href="{{tosDocumentUrl}}" target="_blank" class="c-company">{{('REGISTER.COMPANY_TERMS' | translate) + ' ' + companyName}}</a></span>
                      </div>

                      <!-- MyBenefits Terms & Conditions -->
                      <div class="form-group">
                          <div class="custom-control custom-checkbox">
                              <input class="custom-control-input" type="checkbox" formControlName="mybenefitsTerms" id="register-mybenefits-terms"
                                     tabindex="4"/>
                              <label class="custom-control-label" for="register-mybenefits-terms">
                                  {{'REGISTER.AGREE' | translate}} <a (click)="openNewTab(mybenefitsTermsUrl)" href="javascript:void(0)" target="_blank" class="c-company">{{'REGISTER.MYBENEFITS_TERMS' | translate}}</a>
                              </label>
                              <div *ngIf="(f.mybenefitsTerms.dirty || f.mybenefitsTerms.touched) && f.mybenefitsTerms.errors"
                                  class="invalid-feedback ml-25">
                                  {{'REGISTER.MYBENEFITS_TERMS_REQUIRED' | translate}}
                              </div>
                          </div>
                      </div>

                      <!-- GDPR -->
                      <div class="custom-control custom-checkbox">
                          <input class="custom-control-input" type="checkbox" formControlName="gdprConsent" id="register-gdpr"
                                 tabindex="4"/>
                          <label class="custom-control-label" for="register-gdpr">
                              {{'REGISTER.AGREE_GDPR' | translate}} <a (click)="openNewTab(gdprUrl)" href="javascript:void(0)" class="c-company">{{'FOOTER.GDPR' | translate}}</a>
                          </label>
                          <div *ngIf="(f.gdprConsent.dirty || f.gdprConsent.touched) && f.gdprConsent.errors"
                              class="invalid-feedback ml-25">
                              {{'REGISTER.GDPR_REQUIRED' | translate}}
                          </div>
                      </div>

                      <!-- Privacy Policy -->
                      <div class="custom-control custom-checkbox">
                          <input class="custom-control-input" type="checkbox" formControlName="privacyPolicy" id="register-privacy-policy"
                                 tabindex="4"/>
                          <label class="custom-control-label" for="register-privacy-policy">
                              {{'REGISTER.AGREE' | translate}} <a (click)="openNewTab(privacyPolicyUrl)" href="javascript:void(0)" class="c-company">{{'REGISTER.PRIVACY_POLICY' | translate}}</a>
                          </label>
                          <div *ngIf="(f.privacyPolicy.dirty || f.privacyPolicy.touched) && f.privacyPolicy.errors"
                              class="invalid-feedback ml-25">
                              {{'REGISTER.PRIVACY_POLICY_REQUIRED' | translate}}
                          </div>
                      </div>

                      <button class="btn btn-primary btn-block" tabindex="5" [disabled]="registerForm.invalid" rippleEffect (click)="onSubmit()"><i
                              class="fa fa-arrow-right"></i>
                              {{'REGISTER.CONTINUE' | translate}}
                      </button>
                  </form>
              </div>
          </div>
          <!-- /Register-->
      </div>
  </div>
